import { Badge } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

export const NotificationBellStyled = styled(Badge).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "notification-bell",
})`
  .NotificationBell-Icon {
    color: ${rydeColors.white};
    height: 22px;
  }

  &.MuiBadge-badge.NotificationBell_Active {
    .NotificationBell-Icon {
      color: ${rydeColors.leftMenuHighlight};
    }
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    &.NotificationBell {
      .MuiBadge-badge {
        font-size: 10px;
        height: 16px;
        z-index: unset;
      }
    }
    .NotificationBell-Icon {
      width: 20px;
      height: 22px;
    }
  }
`;
